import React from 'react';
import {
    MenuItem,
    TextField,
    Chip,
    Box,
    SelectChangeEvent,
} from '@mui/material';
import { FormikTouched } from 'formik/dist/types';
import { ISelect } from '../../../../shared/types/shared';

type Props = {
    data?: ISelect[];
    label: string;
    name: string;
    size?: 'small' | 'medium';
    margin?: 'dense' | 'normal' | 'none';
    required?: boolean;
    value?: string[];
    defineValue?: 'value' | 'id';
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
    errors?: any;
    disabled?: boolean;
    onChange?: (event: SelectChangeEvent<string[]>) => void;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const FieldSelectMultiple = ({
    data,
    label,
    name,
    size = 'small',
    margin,
    required,
    touched,
    errors,
    value = [],
    defineValue = 'id',
    disabled,
    onChange,
    onBlur,
}: Props) => {
    const handleDelete = (event: React.MouseEvent, optionToDelete: string) => {
        event.stopPropagation();
        event.preventDefault();
        if (onChange) {
            const newValue = value.filter(
                (option) => option !== optionToDelete
            );
            onChange({
                target: { name, value: newValue },
            } as unknown as SelectChangeEvent<string[]>);
        }
    };

    return (
        <TextField
            id="select-field"
            select
            fullWidth
            label={label}
            name={name}
            value={value}
            required={required}
            margin={margin}
            disabled={disabled}
            onChange={(event) => {
                const selectedValue = event.target.value as unknown as string[];
                const newValue = value.concat(
                    selectedValue.filter((item) => !value.includes(item))
                );
                onChange?.({
                    target: { name, value: newValue },
                } as unknown as SelectChangeEvent<string[]>);
            }}
            size={size}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
            onBlur={onBlur}
            SelectProps={{
                multiple: true,
                renderValue: (selected: unknown) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {Array.isArray(selected) &&
                            selected.map((selectedValue) => {
                                const selectedOption = data?.find((option) =>
                                    defineValue === 'value'
                                        ? option.name === selectedValue
                                        : option.id === selectedValue
                                );
                                return selectedOption ? (
                                    <Chip
                                        key={selectedValue}
                                        label={selectedOption.name}
                                        onMouseDown={(event) =>
                                            event.stopPropagation()
                                        }
                                        onDelete={(event) =>
                                            handleDelete(event, selectedValue)
                                        }
                                    />
                                ) : null;
                            })}
                    </Box>
                ),
            }}
            sx={{
                '& label.Mui-focused': { color: 'primary.main' },
                '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
                },
            }}
        >
            {data
                ?.filter(
                    (option) =>
                        !value.includes(
                            defineValue === 'value'
                                ? option.name
                                : String(option.id)
                        )
                )
                .map((option) => (
                    <MenuItem
                        key={option.id}
                        value={
                            defineValue === 'value'
                                ? option.name
                                : String(option.id)
                        }
                    >
                        {option.name}
                    </MenuItem>
                ))}
        </TextField>
    );
};

export default FieldSelectMultiple;
